import { render, staticRenderFns } from "./offer-detail.vue?vue&type=template&id=60be1121"
import script from "./offer-detail.vue?vue&type=script&lang=js"
export * from "./offer-detail.vue?vue&type=script&lang=js"
import style0 from "./offer-detail.vue?vue&type=style&index=0&id=60be1121&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports